import { normalizeBoolean } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PETITION_PAGE_NEWLY_CREATED_PETITIONS = createFcmConfig('petition_page_newly_created_petitions', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
